module.exports = __webpack_public_path__ + "img/icon-zoom-in.237a2504.svg";